import Request from "./Request";

const DevToolService = {
    async lightspeedPopulateMissingDataFilesForLastMonth() {
        return await Request.get('/api/dev-tools/lightspeed/create-missing-last-month-data-files')
    },
}

export default DevToolService